/** Proxy label from an outbound-call payload. The installed API client does not declare `proxy` yet. */
export function externalCallProxy(call: object | null | undefined): string | null {
  const value = (call as { proxy?: string | null } | null | undefined)?.proxy;
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}
